import { Button, Form, Input, InputNumber, Modal, message, Checkbox, Select } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../server";

const SettingsProgPrice = ({ progId, priceId, licId, onClose }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [item, setItem] = useState(null);
  const [licenses, setLicenses] = useState([]);

  const getLicenses = () => {
    if (!progId) return;
    serverFetch(`dict/license?idProg=${progId}`)
      .then(data => setLicenses(data))
      .catch(e => message.error(e.userMessage));
  };

  const getData = () => {
    if (!priceId) return;
    setLoading(true);
    serverFetch(`dict/price/get?progId=${progId}&licId=${licId}&id=${priceId}`)
      .then(data => {
        setItem(data);
        form.setFieldsValue(data);
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  useEffect(() => { if (priceId && licId) getData(); }, [priceId, licId]);

  useEffect(() => { if (progId) getLicenses(); }, [progId]);

  const onValuesChange = changedValues => setItem(prev => ({ ...prev, ...changedValues }));

  const handleSave = async () => {
    if (!item) return;
    try {
      setLoading(true);
      const method = priceId ? "PUT" : "POST";
      await serverFetch(`dict/price`, {
        method,
        bodyData: priceId ? item : { ...item, progId, licId }
      });
      message.success(priceId ? "Цена обновлена" : "Цена добавлена");
      form.resetFields();
      onClose(true);
    } catch (e) {
      setLoading(false);
      if (e.userMessage) message.error(e.userMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose(false);
  };

  return (
    <div style={{ maxWidth: "90%" }}>
      <Modal
        title={priceId ? "Редактировать цену" : "Добавить цену"}
        open={true}
        onCancel={handleCancel}
        footer={null}
        width={600}
        destroyOnClose
      >
        <Form form={form} onValuesChange={onValuesChange} layout="vertical" disabled={loading}>
          <Form.Item label="Вид лицензии" name="licId" rules={[{ required: true, message: 'Выберите вид лицензии!' }]}>
            <Select placeholder="Выберите вид лицензии" options={licenses.map(license => ({ value: license.idLic, label: license.name }))} />
          </Form.Item>
          <Form.Item label="Активно" name="active" valuePropName="checked">
            <Checkbox />
          </Form.Item>
          <Form.Item label="Наименование" name="name" rules={[{ required: true, message: 'Введите наименование!' }]}>
            <Input placeholder="Введите наименование" />
          </Form.Item>
          <Form.Item label="Кол. мин." name="qtyMin" rules={[{ required: true, message: 'Введите минимальное количество!' }]}>
            <InputNumber min={1} style={{ width: '100%' }} placeholder="Введите минимальное количество" />
          </Form.Item>
          <Form.Item label="Кол. макс." name="qtyMax" rules={[{ required: true, message: 'Введите максимальное количество!' }]}>
            <InputNumber min={1} style={{ width: '100%' }} placeholder="Введите максимальное количество" />
          </Form.Item>
          <Form.Item label="Срок, дней" name="duration" rules={[{ required: true, message: 'Введите срок в днях!' }]}>
            <InputNumber min={1} style={{ width: '100%' }} placeholder="Введите срок в днях" />
          </Form.Item>
          <Form.Item label="Комментарий" name="comment">
            <Input.TextArea rows={3} placeholder="Введите комментарий" />
          </Form.Item>
          <Form.Item label="Цена" name="price" rules={[{ required: true, message: 'Введите цену!' }]}>
            <InputNumber min={0} step={0.01} precision={2} style={{ width: '100%' }} placeholder="Введите цену" />
          </Form.Item>
        </Form>
        <div style={{ marginTop: 16, textAlign: 'right' }}>
          <Button onClick={handleCancel} style={{ marginRight: 8 }}>Отмена</Button>
          <Button type="primary" onClick={handleSave} loading={loading}>Сохранить</Button>
        </div>
      </Modal>
    </div>
  );
};

export default SettingsProgPrice;
